<template>
  <div class="container">
    <div class="silde-box m-b" style="position: relative;" v-if="org.mainUrl">
      <cube-slide ref="slide" :data="items">
        <cube-slide-item>
          <a href class="banner">
            <img :src="org.mainUrl" />
          </a>
        </cube-slide-item>
      </cube-slide>
    </div>
    <div class="introduce m-b">
      <h3>基本信息</h3>
      <div class style="padding-top: 0.8rem">
        <p>
          <span>公司名称:</span>
          <span>{{org.orgName}}</span>
        </p>
        <p>
          <span>公司地址:</span>
          <span>{{org.provinceName+org.cityName+org.districtName+(org.address?org.address:"")}}</span>
        </p>
        <p>
          <span>咨询电话:</span>
          <span>{{org.managerPhone}}</span>
        </p>
        <p>
          <span>企业介绍:</span>
          <span>{{org.corpEName}}</span>
        </p>
      </div>
    </div>
    <div class="store m-b" v-if="org.jdUrl||org.hnUrl||org.tmallUrl">
      <h3>我的网店</h3>
      <div class="img_content">
        <p v-if="org.tmallUrl">
          <a :href="org.tmallUrl">
            <img src="../assets/tb.png" />
          </a>
        </p>
        <p v-if="org.hnUrl">
          <a :href="org.hnUrl">
            <img src="../assets/hn.png" />
          </a>
        </p>
        <p v-if="org.jdUrl">
          <a :href="org.jdUrl">
            <img src="../assets/jd.png" />
          </a>
        </p>
      </div>
    </div>
    <!-- <div class="tab">
      <cube-tab-bar class="bl" v-model="selectedLabelDefault" :data="tabs" @change="changeHandler">
      </cube-tab-bar>
    </div>-->
  </div>
</template>

<script>
import { broducts } from "@/api/bapi";
export default {
  name: "Index",
  data() {
    return {
      menu_show: false,
      menu_show1: false,
      selectedLabelDefault: "首页",
      tabs: [
        {
          label: "首页",
          icon: "cubeic-home"
        },
        {
          label: "我的",
          icon: "cubeic-person"
        }
      ],
      items: [
        {
          url: "",
          image: require("../assets/bg1.jpg")
        }
      ],
      userInfo: {},
      loginShow: false,
      org:{},
    };
  },
  watch: {
    $route(to, from) {
      if (to.path.indexOf("ndex")>0) {
        this.getUserInfo();
      }
    }
  },
  created() {
    this.getUserInfo();
  },
  methods: {
    getUserInfo() {
      this.loginShow = false;
      var u = navigator.userAgent;
      let vue = this;
      if (u.indexOf("MicroMessenger") > 0) {
        this.loginShow = true;
      }
      this.$axios({
        headers: {
          Authorization:
            localStorage.getItem("token_type") +
            localStorage.getItem("access_token")
        },
        method: "get",
        url: "admin/user/loginInfo"
      })
        .then(res => {
          if (res.data.code==0) {
            this.org = res.data.data.org;
          } else {
            vue.$router.push("/login");
          }
        })
        .catch(err => {
          alert("登陆失效，请重新登录");
          vue.$router.push("/login");
        });
    },
    changeHandler(label) {
      if (label == "我的") {
        this.$router.push({ path: "Center" });
      } else {
        this.$router.push({ path: "Index" });
      }
    },
    logout() {
      // 清除localStorage
      logout().then(res => {
        if (res.status == 200) {
          removeLs();
          this.$router.push({ path: "/login" });
        }
      });
    }
  }
};
</script>

<style scoped>
.img_content {
  display: flex;
  margin: 10px 0;
  justify-content: space-around;
}
.store p {
  width: 30%;
}
.store p img {
  width: 100%;
}
.list {
  padding-bottom: 60px;
  margin-top: 10px;
}
.left_img {
  width: 30%;
}
.left_img img {
  width: 100%;
}
.list_content {
  display: flex;
  padding: 5px;
  margin-top: 10px;
  box-shadow: 0px 0px 3px #ece6e6;
}
.title {
  width: 70%;
  text-align: left;
}
h4 {
  font-size: 1rem;
  margin-top: 1.3rem;
  color: #2c3e50;
  margin-left: 1rem;
}
.sub {
  font-size: 0.8rem;
  margin-top: 1.3rem;
  color: red;
  margin-left: 1rem;
}
.more {
  float: right;
  color: #b8b8b8;
  font-size: 0.8rem;
}
.look {
  float: right;
  color: #45b035;
}
.it {
  font-size: 0.6rem;
  margin: 5px 0;
  margin-left: 1rem;
}
.img_content img {
  border-radius: 6px;
}
.ej {
  position: absolute;
  width: 100%;
  background-color: #45b035;
  left: 0;
  top: 38px;
  z-index: 100;
  text-align: right;
}
.ej li {
  width: 100%;
  text-align: center;
  color: white;
  border-bottom: 1px solid #fff;
}

.ej li a {
  width: 100%;
  text-align: center;
  color: white;
}
.ej li a:hover {
  color: white;
}
</style>
<style lang="scss" scoped>
.introduce {
  text-align: left;
  font-size: 0.8rem;
  color: #999999;
  background-color: white;
  padding: 0.8rem;
}
.introduce p {
  margin-bottom: 0.5rem;
}
.silde-box {
  background-color: #f5f5f5;
}
</style>



// WEBPACK FOOTER //
// src/components/Index.vue